import React, {useEffect} from "react";
import {useApiQuery} from "../../services/useApiQuery.ts";
import {Access} from "../../services/types.ts";
import AccessKeyPrompt from "../accessKey/AccessKeyPrompt.tsx";
import {Card, Spinner} from "@fluentui/react-components";
import {useTranslation} from "react-i18next";
import {useSetAtom} from "jotai";
import {processPlotAtom} from "../../store.ts";

interface SecuredWrapperProps {
    children: any;
    initialized: boolean;
}

export const SecuredWrapper: React.FC<SecuredWrapperProps> = (props: SecuredWrapperProps) => {
    const { t } = useTranslation();
    const setProcessPlotAtom = useSetAtom(processPlotAtom)

    const {
        data: access,
        refetch: recheckAccess,
        isPending: accessLoading,
    } = useApiQuery<Access>('/api/access/check');

    const accessGranted = access?.access === true;

    useEffect(() => {
        if (access?.processplot) {
            setProcessPlotAtom(access?.processplot)
        }
    }, [access]);

    if (accessLoading) {
        return <Card><Spinner label={t("text.checking-credentials")}/></Card>;
    }

    return <div>
        {!accessGranted && <AccessKeyPrompt recheckAccess={recheckAccess}/>}
        {accessGranted && props.children}
    </div>
}